import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import Slider from 'react-slick';

import TopBar from '~/components/index/TopBar/TopBar';
import {
  BannerCenterContent,
  Banner2DescImg,
  Banner3DescImg,
  Banner4DescImg,
  Banner5DescImg,
  Banner6DescImg,
  Banner7DescImg,
  Banner8DescImg,
  Slogan,
} from '~/components/SVG/Banner';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import css from './Banner.less';

const isVideoSource = src => typeof src === 'string' && /(\.mp4|\.webm)(?:\?.*)?$/i.test(src);
const getVideoPoster = src => {
  if (!isVideoSource(src)) {
    return src;
  }
  const separator = src.includes('?') ? '&' : '?';
  return `${src}${separator}vframe/jpg/offset/1`;
};

const iphoneGray = require('~/static/index/iphone_gray_bar.png');
const iphoneWhite = require('~/static/index/iphone_white_bar.png');

const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

const ArrowNext = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      preserveAspectRatio="xMidYMid slice"
    >
      <circle opacity="0.15" cx="28" cy="28" r="24" fill="white" />
      <path
        d="M24.5 37L32.3686 29.1314C32.7646 28.7354 32.9627 28.5373 33.0368 28.309C33.1021 28.1082 33.1021 27.8918 33.0368 27.691C32.9627 27.4627 32.7646 27.2646 32.3686 26.8686L24.5 19"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ArrowPrev = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      preserveAspectRatio="xMidYMid slice"
    >
      <circle opacity="0.15" cx="28" cy="28" r="24" fill="white" />
      <path
        d="M31.5 37L23.6314 29.1314C23.2354 28.7354 23.0373 28.5373 22.9632 28.309C22.8979 28.1082 22.8979 27.8918 22.9632 27.691C23.0373 27.4627 23.2354 27.2646 23.6314 26.8686L31.5 19"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const slides = [
  {
    id: 'hero-1',
    background: 'https://free-video.xindebaby.com/banner1.mp4',
    sloganImage: Slogan,
    descImg: BannerCenterContent,
    variant: 'center',
  },
  {
    id: 'hero-2',
    background: 'https://free-video.xindebaby.com/banner1.mp4',
    phone: {
      animation: 'https://free-video.xindebaby.com/banner2_screenshot.mp4',
      frames: [iphoneGray],
      position: 'left',
    },
    descImg: Banner2DescImg,
    textAlign: 'right',
  },
  {
    id: 'hero-3',
    background: 'https://free-video.xindebaby.com/banner3.mp4',
    phone: {
      animation: 'https://free-video.xindebaby.com/banner3_screenshot.mp4',
      frames: [iphoneGray],
      position: 'right',
    },
    descImg: Banner3DescImg,
    textAlign: 'left',
  },
  {
    id: 'hero-4',
    background: 'https://free-video.xindebaby.com/banner4.mp4',
    phone: {
      animation: 'https://free-video.xindebaby.com/banner4_screenshot.mp4',
      frames: [iphoneWhite],
      position: 'left',
    },
    descImg: Banner4DescImg,
    textAlign: 'right',
  },
  {
    id: 'hero-5',
    background: 'https://free-video.xindebaby.com/banner5.mp4',
    phone: {
      animation: 'https://free-video.xindebaby.com/banner5_screenshot.mp4',
      frames: [iphoneWhite],
      position: 'right',
    },
    descImg: Banner5DescImg,
    isSvg: true,
    textAlign: 'left',
  },
  {
    id: 'hero-6',
    background: 'https://free-video.xindebaby.com/banner6.mp4',
    phone: {
      animation: 'https://free-video.xindebaby.com/banner6_screenshot.mp4',
      frames: [iphoneWhite],
      position: 'left',
    },
    descImg: Banner6DescImg,
    textAlign: 'right',
  },
  {
    id: 'hero-7',
    background: 'https://free-video.xindebaby.com/banner7.mp4',
    phone: {
      animation: 'https://free-video.xindebaby.com/banner7_screenshot.mp4',
      frames: [iphoneWhite],
      position: 'right',
    },
    descImg: Banner7DescImg,
    textAlign: 'left',
  },
  {
    id: 'hero-8',
    background: 'https://free-video.xindebaby.com/banner8.mp4',
    phone: {
      animation: 'https://free-video.xindebaby.com/banner8_screenshot.mp4',
      frames: [iphoneWhite],
      position: 'left',
    },
    descImg: Banner8DescImg,
    textAlign: 'right',
  },
];

const NextArrow = ({ className, style, onClick, currentSlide }) => (
  <button
    type="button"
    className={classNames(css.arrowNext, className, { [css.isHidden]: currentSlide === slides.length - 1 })}
    style={style}
    onClick={onClick}
    aria-label="下一张"
  >
    {/* <img src={arrowNext} alt="" aria-hidden="true" /> */}
    <ArrowNext />
  </button>
);

const PrevArrow = ({ className, style, onClick, currentSlide }) => (
  <button
    type="button"
    className={classNames(css.arrowPrev, className, { [css.isHidden]: currentSlide === 0 })}
    style={style}
    onClick={onClick}
    aria-label="上一张"
  >
    {/* <img src={arrowPrev} alt="" aria-hidden="true" /> */}
    <ArrowPrev />
  </button>
);

const Banner = () => {
  const [isTopBarCondensed, setIsTopBarCondensed] = useState(false);
  const [loadedSlides, setLoadedSlides] = useState(new Set([0, 1]));
  const [phoneVideoErrorMap, setPhoneVideoErrorMap] = useState({});
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsTopBarCondensed(window.scrollY > 40);
    };

    handleScroll();
    setIsAndroid(/android/i.test(window.navigator.userAgent || ''));
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const settings = useMemo(
    () => ({
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: false,
      // autoplaySpeed: 6000,
      // speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: true,
      variableWidth: false,
      centerMode: false,
      adaptiveHeight: false,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      beforeChange: (current, next) => {
        setLoadedSlides(prev => {
          const nextNext = (next + 1) % slides.length;
          if (prev.has(next) && prev.has(nextNext)) return prev;
          const newSet = new Set(prev);
          newSet.add(next);
          newSet.add(nextNext);
          return newSet;
        });
      },
    }),
    [],
  );

  const markPhoneVideoError = slideId => {
    setPhoneVideoErrorMap(prev => {
      if (prev[slideId]) {
        return prev;
      }
      return {
        ...prev,
        [slideId]: true,
      };
    });
  };

  const androidVideoProps = isAndroid
    ? {
        'webkit-playsinline': 'true',
        'x5-playsinline': 'true',
        'x5-video-orientation': 'portrait',
      }
    : {};

  const handleVideoCanPlay = event => {
    const video = event.currentTarget;
    const promise = video.play();
    if (promise !== undefined) {
      promise.catch(() => {
        // autoplay blocked, user interaction required
      });
    }
  };

  const handlePhoneFallbackError = event => {
    if (event.currentTarget && event.currentTarget.dataset.fallbackApplied !== 'true') {
      event.currentTarget.dataset.fallbackApplied = 'true';
      event.currentTarget.src = transparentPixel;
    }
  };

  const renderPhone = (slide, shouldLoadVideo) => {
    const { phone } = slide;
    if (!phone) {
      return null;
    }

    const isPhoneVideo = isVideoSource(phone.animation);
    const hasVideoError = Boolean(phoneVideoErrorMap[slide.id]);
    const phonePoster = phone.poster || getVideoPoster(phone.animation) || transparentPixel;
    const shouldRenderVideo = isPhoneVideo && shouldLoadVideo && !hasVideoError;

    return (
      <div className={classNames(css.phone, phone.position === 'left' ? css.phoneLeft : css.phoneRight)}>
        <div className={classNames(css.phoneScreen, { [css.phoneScreenFallback]: isPhoneVideo })}>
          {shouldRenderVideo ? (
            <video
              src={phone.animation}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              poster={phonePoster}
              onCanPlay={handleVideoCanPlay}
              onError={() => markPhoneVideoError(slide.id)}
              {...androidVideoProps}
            />
          ) : (
            <img src={isPhoneVideo ? phonePoster : phone.animation} alt="" onError={handlePhoneFallbackError} />
          )}
        </div>
        <div className={css.phoneFrame}>
          {phone.frames.map(src => (
            <img key={src} src={src} alt="" />
          ))}
        </div>
      </div>
    );
  };

  return (
    <section className={css.banner}>
      <TopBar
        className={classNames(css.topBar, { [css.topBarSticky]: isTopBarCondensed })}
        isCondensed={isTopBarCondensed}
      />
      <Slider {...settings} className={css.slider}>
        {slides.map((slide, index) => {
          const shouldLoadVideo = loadedSlides.has(index);

          const renderBackground = () => {
            if (!isVideoSource(slide.background)) {
              return <div className={css.background} style={{ backgroundImage: `url(${slide.background})` }} />;
            }
            if (shouldLoadVideo) {
              return (
                <video
                  className={classNames(css.background, css.backgroundVideo)}
                  src={slide.background}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  onCanPlay={handleVideoCanPlay}
                  {...androidVideoProps}
                />
              );
            }
            return <div className={css.background} style={{ backgroundColor: '#2e2e2e' }} />;
          };

          return (
            // 判断当前 slide 是否应该加载视频
            <div className={css.slide} key={slide.id}>
              {renderBackground()}
              <div className={css.overlayMask} />
              <div className={css.overlayGradient} />
              <div className={classNames(css.slideInner, { [css.centered]: slide.variant === 'center' })}>
                {slide.variant === 'center' ? (
                  <div className={css.centerContent}>
                    <div className={css.sloganImage}>
                      <slide.sloganImage />
                    </div>
                    <div className={css.sloganDescImage}>
                      <slide.descImg />
                    </div>
                  </div>
                ) : (
                  <>
                    {slide.phone?.position === 'left' ? renderPhone(slide, shouldLoadVideo) : null}
                    <div className={css.descImg}>
                      <slide.descImg />
                    </div>
                    {slide.phone?.position === 'right' ? renderPhone(slide, shouldLoadVideo) : null}
                  </>
                )}
              </div>
            </div>
          );
        })}
      </Slider>
    </section>
  );
};

export default Banner;
